import { NextResponse, type NextRequest } from 'next/server'
import { type GetOrderProviderAdapter, type GetOrderRouteResponse } from './types'

/**
 * The get-order flow, shared by every payment provider.
 *
 * One behavioural difference from the pages version: a provider that answers
 * with neither an error nor a record is now a 400. Klarna already treated that
 * as a failure; the other four returned a 200 whose body serialised to `{}`,
 * leaving the confirmation page with no order and no reason why. The stricter
 * check is Klarna's, applied to all five.
 */
export const runGetOrder = async <TOrder>(
  request: NextRequest,
  adapter: GetOrderProviderAdapter<TOrder>
): Promise<GetOrderRouteResponse> => {
  const orderId = request.nextUrl.searchParams.get('orderId')

  if (!orderId) {
    return NextResponse.json({ error: 'OrderId was not provided' }, { status: 400 })
  }

  const { error, data: order } = await adapter.retrieve(orderId)

  if (error || !order) {
    return NextResponse.json({ error: error || 'Unknown error' }, { status: 400 })
  }

  return NextResponse.json(adapter.respond(order))
}
